module.exports = __webpack_public_path__ + "static/media/slide-levels.1d38c2d1.svg";